/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust4_NInputs */

const es_landing_trust4_n = /** @type {(inputs: Landing_Trust4_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs`)
};

const gl_landing_trust4_n = /** @type {(inputs: Landing_Trust4_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes`)
};

const en_landing_trust4_n = /** @type {(inputs: Landing_Trust4_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs`)
};

/**
* | output |
* | --- |
* | "Clubs" |
*
* @param {Landing_Trust4_NInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_trust4_n = /** @type {((inputs?: Landing_Trust4_NInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust4_NInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_trust4_n(inputs)
	if (locale === "en") return en_landing_trust4_n(inputs)
	return es_landing_trust4_n(inputs)
});